<div class="row">
  <div class="col-12 d-flex justify-content-center">
    <mat-spinner></mat-spinner>
  </div>
</div>
<p class="custom-loading-text">{{loadingMessage}}</p>


